import script from "./AgendaHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaHeader.vue?vue&type=script&setup=true&lang=js"

import "./AgendaHeader.vue?vue&type=style&index=0&id=1311061c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1311061c"]])

export default __exports__